import { pathEndsWithSlash } from './utils';

/* eslint-disable no-console */
let baseUrl = '/';
let prefixTmp = '';

if (document.currentScript) {
    console.log((document.currentScript as any).src, 'document.currentScript.src');

    baseUrl = /^.+\/(?=.+)/.exec((document.currentScript as any).src)?.[0] ?? '/';

    prefixTmp = /(?<=https?:\/\/[^/]+)\/(.+)/.exec(baseUrl)?.[0] ?? '';

    console.log(baseUrl, 'baseUrl');
}

export const prefix = pathEndsWithSlash(prefixTmp);

// eslint-disable-next-line camelcase
__webpack_public_path__ = baseUrl;
